import React, { useContext, useEffect, useState } from 'react';

import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { GlobalContext } from '../../../../../../store';
import { TFlightCategory } from '../../../../../../store/admin/eventFlights/store';

import Tooltip from '../../../../../../components/Tooltip';
import Switch from '../../../../../../components/YesNoSwitch';
import FlightsRows from '../FlightsRows/FlightsRows';
import { modalsMetadata } from '../FlightsRows/Utils/modalsMetadata';
import { FlightsModal } from '../FlightsModal/FlightsModal';
import { typeAction } from '../../Utils/typeAction';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { useGetAdminEvent } from '../../../../../../contrib/Hooks/useGetAdminEvent';
import { FlightsSectionContainerStyled } from './FlightsSectionContainer.Styles';
import { TitleContainerStyled } from './TitleContainerStyled';

interface IProps {
  category: TFlightCategory;
  setFlightsNotSaved: any;
}

const FlightsSection = (props: IProps) => {
  const { category, setFlightsNotSaved } = props;

  const {
    actions: {
      adminEvents: { edit: editEvent },
      notifications: { pushError }
    }
  } = useContext(GlobalContext);

  const { clubId, eventId } = useRouteInfoState();

  const event = useGetAdminEvent(eventId);

  const [modalVisible, setModalVisible] = useState(false);
  const [modal, setModal] = useState({ text: '', title: '' });
  const [modalVar, setModalVar] = useState<typeAction>('automaticHandicaps');

  const [useFlights, setUseFlights] = useState(false);
  const [flightsByAge, setFlightsByAge] = useState(false);
  const [flightsByHandicap, setFlightsByHandicap] = useState(false);
  const [flightsLength, setFlightsLength] = useState(0);
  const [title, settitle] = useState('');

  const openConfirmationModalFor = (type: typeAction) => async () => {
    if (!event) {
      return;
    }

    if (event[type]) {
      setModal(modalsMetadata[type]);
      setModalVar(type);
      setModalVisible(!modalVisible);
    } else {
      await onChangeFlightsBy(type)();
    }
  };

  const onChangeFlightsBy = (type: typeAction) => async () => {
    if (!event) {
      return;
    }

    const response = await editEvent(Number(clubId), {
      ...event,
      [type]: !event[type]
    });

    if (response.errors) {
      pushError('Your action could not be completed');
    }

    setModalVisible(false);
  };

  useEffect(() => {
    if (event) {
      setUseFlights(!!event.useFlights);
      setFlightsLength(event.flights.length);

      setFlightsByAge(event.flightsByAge);
      setFlightsByHandicap(event.flightsByHandicap);
    }
  }, [event]);

  useEffect(() => {
    const categoryMap = {
      i: 'INDIVIDUAL GAMES',
      t: 'TEAMS'
    };

    settitle(`FLIGHTS FOR ${categoryMap[category]}`);
  }, [category]);

  return (
    <FlightsSectionContainerStyled
      elevation={1}
      useFlights={useFlights}
      flightsLength={flightsLength}
      className={'paper paper-full'}
    >
      <TitleContainerStyled>
        <h3 className="title-tooltip override">{title}</h3>

        <Tooltip
          classes={{ fab: 'tooltip-fab--shift-top-2dot5' }}
          sectionKey="EVENT_SETUP.FLIGHTS"
        />
      </TitleContainerStyled>

      <div className="admin-form-field flights-options">
        <div className="label-row-grey">
          <div>HOW ARE FLIGHTS DISTINGUISHED?</div>
        </div>

        <div className="admin-form-radios label-row-grey">
          <FormControlLabel
            color="primary"
            control={<Checkbox checked={flightsByAge} color="primary" />}
            label="Age range"
            onChange={openConfirmationModalFor('flightsByAge')}
          />

          <div className="form-control-tooltip">
            <FormControlLabel
              color="primary"
              control={<Checkbox checked={flightsByHandicap} color="primary" />}
              label="By Index"
              onChange={openConfirmationModalFor('flightsByHandicap')}
            />

            <Tooltip sectionKey="EVENT_SETUP.HANDICAP_RANGE" />
          </div>

          {event && event.flightsByHandicap && (
            <div className="toggle set-ranges">
              <div>SET RANGES</div>

              <div className="toggle">
                <Switch
                  checked={event && event.automaticHandicaps}
                  onChange={onChangeFlightsBy('automaticHandicaps')}
                  color="primary"
                  labelYes="AUTOMATICALLY"
                  labelNo="MANUALLY"
                />
              </div>
            </div>
          )}
        </div>

        <FlightsRows
          onLengthChange={setFlightsLength}
          onNotSavedChange={setFlightsNotSaved}
          category={category}
        />
      </div>

      <FlightsModal
        setModalState={openConfirmationModalFor}
        modalVisible={modalVisible}
        modalVar={modalVar}
        onChangeFlightsBy={onChangeFlightsBy}
        modal={modal}
      />
    </FlightsSectionContainerStyled>
  );
};

export default FlightsSection;
